// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// Element组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// Ant组件
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import App from './App'
import router from './router'
import 'lib-flexible'
import less from 'less'

// 国际化
import VueI18n from "vue-i18n";
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import zh from './lang/zh'
import en from './lang/en'
import tw from './lang/tw'
import api from "../static/ipConfig.js"
// 懒加载
import VueLazyload from 'vue-lazyload'
Vue.prototype.api = api.api;

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(Antd);
Vue.use(less)
Vue.use(VueLazyload,{
  loading:require('./assets/images/loading.gif')
})   
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



const i18n = new VueI18n({
  // 设置默认语言
  locale: localStorage.getItem('locale') || 'zh', //切换语言
  messages: { zh, en, tw },
  fallbackLocale: 'zh', // 如果在message中找不到相应的键值将回退到原本的语言
  formatFallbackMessages: true // 如果在message中找不到相应的键值将回退到原本的语言
});
locale.use(lang)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js